<script>
  import {cn} from "$lib/utils.js";
  import HeadCell from "./bits/calendar-head-cell.svelte";

  let {ref = $bindable(null), class: className, ...restProps} = $props();
</script>

<HeadCell
  bind:ref
  style="font-weight: bold;"
  class={cn("text-muted-foreground w-9 rounded-md text-[0.8rem] font-normal", className)}
  {...restProps}
/>
